import { useState } from 'react'
import { useDispatch } from 'react-redux'

import { DrawerBodyWrapper, DrawerFooterWrapper, TOAST_TYPE } from '@base'
import { Button, Input } from '@baseV2'
import { strings } from '@constants'
import { addInOrderBook } from '@data'
import { showLoader, showToast } from '@data/state/action'

// Puts one enquiry on the order book. The drawer stays open after a submit, so several enquiries
// can be added one after the other — only the field is cleared, on success.
const AddToOrderbook = () => {
	const dispatch = useDispatch()
	const [enquiryId, setEnquiryId] = useState('')

	const submitHandler = () => {
		const id = enquiryId.trim()
		if (!id) return

		dispatch(showLoader(true))
		addInOrderBook(id)
			.then(() => {
				dispatch(showToast(true, strings('msg_added_to_orderbook'), { type: TOAST_TYPE.SUCCESS }))
				setEnquiryId('')
			})
			.catch((error) => {
				const message = error?.response?.data?.message ?? error?.data?.message ?? error?.message
				dispatch(showToast(true, message || strings('error_something_went_wrong'), { type: TOAST_TYPE.ERROR }))
			})
			.finally(() => {
				dispatch(showLoader(false))
			})
	}

	return (
		<>
			<DrawerBodyWrapper>
				<Input
					id='orderbook-enquiry-id'
					type='text'
					label={strings('enquiry_id')}
					placeholder={strings('enter', 'enquiry_id')}
					value={enquiryId}
					onChange={(e) => setEnquiryId(e.target.value)}
				/>
			</DrawerBodyWrapper>
			{/* sits on the bottom edge of the drawer, whatever the body's height. The wrapper lays its
			    children out in reverse, so the lone button lands on the right. */}
			<DrawerFooterWrapper>
				<Button type='button' color='primary' disabled={!enquiryId.trim()} onClick={submitHandler}>
					{strings('submit')}
				</Button>
			</DrawerFooterWrapper>
		</>
	)
}

export default AddToOrderbook
